import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo1-default.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolling(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    {
      label: 'Kurumsal',
      path: '/kurumsal',
      submenu: [
        { label: 'Gelişim Ailesi', to: '/kurumsal#gelisim-ailesi' },
        { label: 'Yönetim', to: '/kurumsal#yonetim' },
        { label: 'Bülten ve Yayınlarımız', to: '/kurumsal#bulten' },
        { label: 'Kişisel Verilerin Korunması', to: '/kurumsal#kvkk' },
      ],
    },
    {
      label: 'Okullarımız',
      submenu: [
        { label: 'Anaokulu', to: '/okullarimiz/anaokulu' },
        { label: 'İlkokul', to: '/okullarimiz/ilkokul' },
        { label: 'Ortaokul', to: '/okullarimiz/ortaokul' },
        { label: 'Lise', to: '/okullarimiz/lise' },
      ],
    },
    {
      label: 'Kampüs Olanakları',
      path: '/kampus',
      submenu: [
        { label: 'Eğitim Öğretim Alanları', to: '/kampus#egitim' },
        { label: 'Kültür Sanat Alanları', to: '/kampus#kultur' },
        { label: 'Spor Kompleksleri', to: '/kampus#spor' },
        { label: 'Teknoloji Laboratuvarı', to: '/kampus#teknoloji' },
        { label: 'Fen Laboratuvarı', to: '/kampus#fen' },
        { label: 'Görsel Sanatlar', to: '/kampus#gorsel' },
        { label: 'Müzik Odası', to: '/kampus#muzik' },
        { label: 'Montessori Atölyeleri', to: '/kampus#montessori' },
        { label: 'Yemekhaneler', to: '/kampus#yemekhane' },
        { label: 'Bahçe Alanları', to: '/kampus#bahce' },
      ],
    },
    {
      label: 'Etkinlikler',
      path: '/etkinlikler/genel',
      submenu: [
        { label: 'Anaokulu', to: '/etkinlikler/anaokulu' },
        { label: 'İlkokul', to: '/etkinlikler/ilkokul' },
        { label: 'Ortaokul', to: '/etkinlikler/ortaokul' },
        { label: 'Lise', to: '/etkinlikler/lise' },
        { label: 'Genel', to: '/etkinlikler/genel' },
      ],
    },
  ];

  return (
    <div className={`fixed top-0 left-0 w-full z-50 transition duration-300 ${scrolling ? 'shadow-md' : ''}`}>      
      <nav className="bg-white">
        <div className="w-full flex items-center justify-between px-4 md:px-8 py-3">
          <div className="flex items-center gap-x-12">
            <Link to="/">
              <img src={logo} alt="Logo" className="h-12" />
            </Link>

            <div className="hidden md:flex gap-x-10 text-gray-800 font-medium">
              {menuItems.map(({ label, path, submenu }) => (
                <div key={label} className="relative group">
                  {path ? (
                    <Link
                      to={path}
                      className="transition-colors duration-300 group-hover:text-[#a03838]"
                    >
                      {label}
                      <span className="absolute left-0 bottom-0 w-full h-[2px] bg-[#a03838] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
                    </Link>
                  ) : (
                    <span className="transition-colors duration-300 cursor-pointer group-hover:text-[#a03838]">
                      {label}
                      <span className="absolute left-0 bottom-0 w-full h-[2px] bg-[#a03838] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
                    </span>
                  )}
                  <div className="absolute left-0 top-full mt-2 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 flex flex-col bg-white shadow-lg rounded-md z-50 min-w-[220px] border border-gray-200 invisible group-hover:visible">
                    {submenu.map(({ label, to }) => (
                      <Link
                        key={to}
                        to={to}
                        className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]"
                      >
                        {label}
                      </Link>
                    ))}
                  </div>
                </div>
              ))}

              <Link to="/contact" className="relative group">
                <span className="hover:text-[#a03838] transition-colors duration-300">
                  İletişim
                </span>
                <span className="absolute left-0 bottom-0 w-full h-[2px] bg-[#a03838] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
              </Link>
            </div>
          </div>

          <div className="md:hidden">
            <button onClick={() => setMenuOpen(!menuOpen)} className="text-gray-800">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="md:hidden px-4 pb-4 flex flex-col gap-2 bg-white text-gray-800 max-h-[calc(100vh-60px)] overflow-y-auto">
            {menuItems.map(({ label, submenu }) => (
              <div key={label} className="border-t pt-2">
                <p className="font-semibold mb-2">{label}</p>
                {submenu.map(({ label, to }) => (
                  <Link
                    key={to}
                    to={to}
                    onClick={() => setMenuOpen(false)}
                    className="block pl-4 py-1 text-sm hover:text-[#a03838]"
                  >
                    {label}
                  </Link>
                ))}
              </div>
            ))}
            <Link to="/contact" onClick={() => setMenuOpen(false)} className="pt-2 font-semibold hover:text-[#a03838]">
              İletişim
            </Link>
          </div>
        )}
      </nav>
    </div>
  );
};

export default Navbar;




// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import logo from '../assets/images/logo1-default.png';

// const Navbar = () => {
//   const [showNavbar, setShowNavbar] = useState(true);
//   const [lastScrollY, setLastScrollY] = useState(0);
//   const [menuOpen, setMenuOpen] = useState(false);

// useEffect(() => {
//     const handleScroll = () => {
//       const currentY = window.scrollY;
//       if (currentY > lastScrollY) setShowNavbar(false);
//       else setShowNavbar(true);
//       setLastScrollY(currentY);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, [lastScrollY]);

//   return (
//     <div
//      className={`fixed top-0 left-0 w-full z-50 transition-transform duration-500 ${
//       showNavbar ? 'translate-y-0' : '-translate-y-full' // Corrected typo here
//      } hover:translate-y-0`}
//     >
//     <nav className="bg-white shadow-md">
//       <div className="w-full flex items-center justify-between px-4 md:px-8 py-3">
//         {/* Sol taraf: Logo + Menü */}
//         <div className="flex items-center gap-x-12">
//           <Link to="/">
//             <img src={logo} alt="Logo" className="h-12" />
//           </Link>

//           <div className="hidden md:flex gap-x-10 text-gray-800 font-medium">
//             {/* ÖZEL: Kurumsal dropdown */}
//             <div className="relative group"> {/* This is the group parent */}
//                 {/* Ana Link - Removed redundant 'relative group' */}
//                 <Link to="/kurumsal">
//                     <span className="transition-colors duration-300 group-hover:text-[#a03838]">
//                     Kurumsal
//                     </span>
//                     <span className="absolute left-0 bottom-0 w-full h-[2px] bg-[#a03838] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
//                 </Link>

//                 {/* Dropdown Menü */}
//                 <div className="absolute left-0 top-full mt-2 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 translate-y-2 transition-all duration-300 flex flex-col bg-white shadow-lg rounded-md z-50 min-w-[220px] border border-gray-200">
//                     <Link to="/kurumsal#gelisim-ailesi" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Gelişim Ailesi</Link>
//                     <Link to="/kurumsal#yonetim" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Yönetim</Link>
//                     <Link to="/kurumsal#bulten" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Bülten ve Yayınlarımız</Link>
//                     <Link to="/kurumsal#kvkk" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Kişisel Verilerin Korunması</Link>
//                 </div>
//             </div>
//             {/* ÖZEL: Okullarımız dropdown */}
//             <div className="relative group"> {/* This is the group parent */}

//                 <span className="transition-colors duration-300 group-hover:text-[#a03838]">
//                 Okullarımız
//                 </span>
//                 <span className="absolute left-0 bottom-0 w-full h-[2px] bg-[#a03838] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>


//                 <div className="absolute left-0 top-full mt-2 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 translate-y-2 transition-all duration-300 flex flex-col bg-white shadow-lg rounded-md z-50 min-w-[220px] border border-gray-200">
//                     <Link to="/okullarimiz/anaokulu" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Anaokulu</Link>
//                     <Link to="/okullarimiz/ilkokul" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">İlkokul</Link>
//                     <Link to="/okullarimiz/ortaokul" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Ortaokul</Link>
//                     <Link to="/okullarimiz/lise" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Lise</Link>
//                 </div>
//             </div>
//             {/* ÖZEL: Kampus Olanakları dropdown */}
//             <div className="relative group"> {/* This is the group parent */}
//                 {/* Ana Link - Removed redundant 'relative group' */}
//                 <Link to="/kampus">
//                     <span className="transition-colors duration-300 group-hover:text-[#a03838]">
//                     Kampüs Olanakları
//                     </span>
//                     <span className="absolute left-0 bottom-0 w-full h-[2px] bg-[#a03838] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
//                 </Link>

//                 {/* Dropdown Menü */}
//                 <div className="absolute left-0 top-full mt-2 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 translate-y-2 transition-all duration-300 flex flex-col bg-white shadow-lg rounded-md z-50 min-w-[260px] border border-gray-200">
//                     <Link to="/kampus#egitim" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Eğitim Öğretim Alanları</Link>
//                     <Link to="/kampus#kultur" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Kültür Sanat Alanları</Link>
//                     <Link to="/kampus#spor" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Spor Kompleksleri</Link>
//                     <Link to="/kampus#teknoloji" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Teknoloji Laboratuvarı</Link>
//                     <Link to="/kampus#fen" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Fen Laboratuvarı</Link>
//                     <Link to="/kampus#gorsel" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Görsel Sanatlar</Link>
//                     <Link to="/kampus#muzik" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Müzik Odası</Link>
//                     <Link to="/kampus#montessori" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Montessori Atölyeleri</Link>
//                     <Link to="/kampus#yemekhane" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Yemekhaneler</Link>
//                     <Link to="/kampus#bahce" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Bahçe Alanları</Link>
//                 </div>
//             </div>
//             {/* ÖZEL: Etkinlikler dropdown */}
//             <div className="relative group"> {/* This is the group parent */}
//             {/* Ana Link - Removed redundant 'relative group' */}
//             <Link to="/etkinlikler/genel">
//                 <span className="transition-colors duration-300 group-hover:text-[#a03838]">
//                 Etkinlikler
//                 </span>
//                 <span className="absolute left-0 bottom-0 w-full h-[2px] bg-[#a03838] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
//             </Link>

//             <div className="absolute left-0 top-full mt-2 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 translate-y-2 transition-all duration-300 flex flex-col bg-white shadow-lg rounded-md z-50 min-w-[220px] border border-gray-200">
//                 <Link to="/etkinlikler/anaokulu" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Anaokulu</Link>
//                 <Link to="/etkinlikler/ilkokul" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">İlkokul</Link>
//                 <Link to="/etkinlikler/ortaokul" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Ortaokul</Link>
//                 <Link to="/etkinlikler/lise" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Lise</Link>
//                 <Link to="/etkinlikler/genel" className="px-4 py-2 hover:bg-[#f8f8f8] hover:text-[#a03838]">Genel</Link>
//             </div>
//             </div>


//             {/* DİĞER MENÜLER */}
//             {[
//               { label: 'İletişim', to: '/contact' }
//             ].map((item) => (
//               <Link key={item.to} to={item.to} className="relative group">
//                 <span className="hover:text-[#a03838] transition-colors duration-300">
//                   {item.label}
//                 </span>
//                 <span className="absolute left-0 bottom-0 w-full h-[2px] bg-[#a03838] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
//               </Link>
//             ))}
//           </div>
//         </div>

//           {/* Sağ taraf: Hamburger butonu */}
//           <div className="md:hidden">
//             <button onClick={() => setMenuOpen(!menuOpen)} className="text-gray-800">
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2}
//                 viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round"
//                   d="M4 6h16M4 12h16M4 18h16" />
//               </svg>
//             </button>
//           </div>
//         </div>

//         {/* Mobil Menü */}
//         {menuOpen && (
//           <div className="md:hidden px-4 pb-4 flex flex-col gap-2 bg-white text-gray-800">
//             <Link to="/kurumsal" onClick={() => setMenuOpen(false)}>Kurumsal</Link>
//             <Link to="/okullarimiz" onClick={() => setMenuOpen(false)}>Okullarımız</Link>
//             <Link to="/kampus" onClick={() => setMenuOpen(false)}>Kampüs Olanakları</Link>
//             <Link to="/etkinlikler" onClick={() => setMenuOpen(false)}>Etkinlikler</Link>
//             <Link to="/contact" onClick={() => setMenuOpen(false)}>İletişim</Link>
//           </div>
//         )}
//       </nav>
//     </div>
//   );
// };

// export default Navbar;
